var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6716 4.37227L13.8434 6.4416C14.1058 6.69519 14.0309 6.89069 13.675 6.89069H12.0461V12.2973C12.0461 12.6683 11.7465 13 11.3906 13H8.56339V9.21299C8.56339 8.84197 8.24526 8.51031 7.88939 8.51031H6.11061C5.75474 8.51031 5.43661 8.84197 5.43661 9.21299V13H2.60938C2.25351 13 1.93538 12.6683 1.93538 12.2973V6.89069H0.324952C-0.0309228 6.89069 -0.105812 6.69519 0.1566 6.4416L6.50363 0.429732C6.76605 0.17614 7.21538 0.17614 7.49577 0.429732L8.93724 1.77639V0.702686C8.93724 0.331668 9.25537 0 9.61125 0H11.0156C11.3714 0 11.671 0.331668 11.671 0.702686L11.6716 4.37227Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIconActive);
export default __webpack_public_path__ + "static/media/dashboard_icon_active.a83d7eb036aceba497f993e449172635.svg";
export { ForwardRef as ReactComponent };